@if (tileItem; as item) {
  @if (item.active === 'false') {
    <div class="inactiveItemContainer">
      <div class="image-box">
        <img src="icons/Maintenance.png" alt="">
      </div>
      <div class="inactiv-item-text-wrapper">
        @if ((item.inActiveTitle | json) != '{}') {
          <div class="text-title">{{ item.inActiveTitle }}</div>
        }
        @if ((item.inActiveText | json) != '{}') {
          <div class="text-description">{{item.inActiveText}}</div>
        }
      </div>
    </div>
  }
  <div
    class="tile-item-container {{ item.hideBorder === 'true' ? 'no-border' : '' }} {{ item.styleClasses ? item.styleClasses : ''}}">
    <div class="tile-item-image  {{ item.styleClasses ? item.styleClasses : ''}}">
      <cx-media [container]="item.medias"></cx-media>
    </div>
    <div class="tile-item-text-wrapper">
      <div class="tile-item-title" [ngClass]="{'title-has-subtitle': item.subtitle}">
        {{ item.title }}
      </div>
      @if (item.subtitle) {
        <div class="tile-item-subtitle" [innerHTML]="item.subtitle">
        </div>
      }
      <div class="tile-item-description">
        {{ item.description }}
      </div>
    </div>
    <div class="tile-item-link">
      <button class="btn btn-primary btn-block {{item.buttonStyle ?? ''}}" (click)="connect()">
        {{ item.buttonText }}
      </button>
    </div>
  </div>
}